import './App.css';
import JobsHome from './pages/JobsHome';

function App() {
  return (
    <div className="App">
      <JobsHome />
    </div>
  );
}

export default App;
